import { createAsyncThunk } from '@reduxjs/toolkit';
import { apiGet } from 'api-service';
import { magicNumbers } from 'utils';
import { setError429 } from './errorSlice';

export const fetchSearchLimitStatus = createAsyncThunk(
  'errorSlice/fetchSearchLimitStatus',
  async (_, thunkAPI) => {
    try {
      const response = await apiGet('/search/api/v1/search/limit/status');
      thunkAPI.dispatch(
        setError429({
          type: 'quarter',
          active: false,
          ttl: magicNumbers?.EVERY_FIFTEEN_MINUTES_IN_SECOND,
        })
      );
      return response;
    } catch (error) {
      if (error?.response?.status === 429) {
        thunkAPI.dispatch(
          setError429({
            type: error.response?.data?.errors?.data?.type,
            active: true,
            ttl:
              error.response?.data?.errors?.data?.ttl ||
              magicNumbers?.EVERY_FIFTEEN_MINUTES_IN_SECOND,
          })
        );
      }
      return thunkAPI.rejectWithValue(error);
    }
  }
);
